// extracted by mini-css-extract-plugin
module.exports = {"root":"IconEdit_root__1dL7V","pencil":"IconEdit_pencil__2kZmq"};